/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { STEPS, STEPS_TITLE } from '../constants';
import { STEPS_FOUR_STAGES, STEPS_TITLE_FOUR_STAGES } from '../constants_four_stages';
import styles from './styles';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';

const PcModelStepsStepMobile = ({ step, completed, active, showTitle }) => {
  let UPDATED_STEPS = STEPS;
  let UPDATED_STEPS_PAGE_TITLES = STEPS_TITLE;

  const { options } = usePcConfigurator();
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS = STEPS_FOUR_STAGES;
      UPDATED_STEPS_PAGE_TITLES = STEPS_TITLE_FOUR_STAGES;
    } else {
      UPDATED_STEPS = STEPS;
      UPDATED_STEPS_PAGE_TITLES = STEPS_TITLE;
    }
  }

  const [, setCurrentStep] = useQueryParam(
    'step',
    withDefault(StringParam, UPDATED_STEPS[0]),
  );

  const handleClick = () => {
    setCurrentStep(step);
    document.getElementById('pc-configurator').scrollIntoView();
  };

  const handleIcon = (step) => {
    if (step == 'build') {
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/steps-core-mobile.svg?v=1714063617';
    } else if (step == 'ultralabs') {
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/steps-styling-mobile.svg?v=1714063790';
    } else if (step == 'accessoriesnew') {
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/steps-accessories-mobile.svg?v=1714063832';
    } else {
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/steps-review-mobile.svg?v=1714063875';
    }
  }

  return (
    <div
      className={classNames('step', { active, completed, showTitle })}
      onClick={handleClick}
    >
      <div className="icon">
        <Image draggable={false}
          src={handleIcon(step)}
          height={16}
          width={16}
          onClick={handleClick}
          alt="step_icon"
        />
      </div>

      {showTitle && <div className="title">{UPDATED_STEPS_PAGE_TITLES[step]}</div>}

      <style jsx>{styles}</style>
    </div>
  );
};

PcModelStepsStepMobile.propTypes = {
  step: PropTypes.string.isRequired,
  completed: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
};

export default PcModelStepsStepMobile;
